import { memo } from "react";

import type { HotelApplicationDataQueryQuery, HotelTopQuery } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandMainWithBackGround } from "@/components/features/_layouts";

import { ExternalLink } from "@/components/ui/button/external-link";

import { HotelUrls } from "./hotel-urls";
import { TestReservation } from "./test-reservation";

type Props = {
	hotelID: string;

	hotelUrls: HotelTopQuery["hotelUrls"];

	inUseBasic: HotelApplicationDataQueryQuery["hotelApplicationStatus"]["inUseBasic"];
	isHotelPolicyRegistered: HotelApplicationDataQueryQuery["hotelApplicationStatus"]["isHotelPolicyRegistered"];
	isTestReservationAvailable: HotelApplicationDataQueryQuery["hotelApplicationStatus"]["isTestReservationAvailable"];
};

export const IslandHotelUrls = memo(
	({ hotelID, hotelUrls, inUseBasic, isHotelPolicyRegistered, isTestReservationAvailable }: Props) => {
		return (
			<FeatureIslandMainWithBackGround>
				<div>
					<div className="flex justify-between">
						<h3 className="text-lg font-semibold">あなたの施設のURL</h3>

						<TestReservation hotelID={hotelID} isTestReservationAvailable={isTestReservationAvailable} />
					</div>

					<ExternalLink
						href="https://chillnn.notion.site/25cfffe15c57802b8293f5e4de6921f2"
						text="プレーン・マガジン・スナックについての説明はこちら"
					/>
				</div>

				<HotelUrls
					hotelUrls={hotelUrls}
					inUseBasic={inUseBasic}
					isHotelPolicyRegistered={isHotelPolicyRegistered}
				/>
			</FeatureIslandMainWithBackGround>
		);
	},
);

IslandHotelUrls.displayName = "IslandHotelUrls";
